import Tab from '@mui/material/Tab';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { tabStyle } from 'src/common/components/AppLayout/AppLayout.styles';
import { a11yTabProps } from 'src/common/components/AppLayout/Components/utils';
import { Routes } from 'src/Routes.constants';

import { TabsLayout } from 'src/common/components/Layouts/TabsLayout/TabsLayout';
import { useSimProvisoningAvailable } from '@/activityLog/bulkProvisioning/Hooks/useSimProvisoningAvailable.ts';
import { useProductsManagementUrlFromFilters } from '@/activityLog/productsManagement/hooks/useProductsManagementUrlFromFilters.ts';
import { useProductsManagementAvailable } from '@/activityLog/productsManagement/hooks/useProductsManagementAvailable.ts';
import { useSsmProvisioningUrlFromFilters } from '@/activityLog/bulkProvisioning/Hooks/useSimProvisioningUrlFromFilters.ts';

export const ActivityLogTabs = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();

  const simProvisioningUrl = useSsmProvisioningUrlFromFilters();
  const productsManagementUrl = useProductsManagementUrlFromFilters();

  const simProvisioningEnabled = useSimProvisoningAvailable();
  const productsManagementEnabled = useProductsManagementAvailable();

  return (
    <TabsLayout content={children}>
      {productsManagementEnabled && (
        <Tab
          sx={tabStyle}
          value={Routes.productsManagement}
          label={t('activityLog.tabs.productsManagement')}
          component={Link}
          to={productsManagementUrl}
          {...a11yTabProps(t('activityLog.tabs.productsManagement'))}
        />
      )}
      {simProvisioningEnabled && (
        <Tab
          sx={tabStyle}
          value={Routes.simProvisioning}
          label={t('activityLog.tabs.simProvisioning')}
          component={Link}
          to={simProvisioningUrl}
          {...a11yTabProps(t('activityLog.tabs.simProvisioning'))}
        />
      )}
    </TabsLayout>
  );
};
